module.exports = "../images/icons/burger-button-white.svg";